import { Injectable } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { Observable } from "rxjs/Observable";
import { FeaturePermission, User } from "../../core/model/user.model";
import { STORE_FEATURE_KEY_USERS, UsersState } from "./user.reducers";
import { Template } from "../../core/model/central/template.model";
import { PermissionItemType } from "../types/permission-item.type";

const selectedUserSelector = (appState: any): User =>
  appState[STORE_FEATURE_KEY_USERS].selectedUser;
const usersSearchLoadingSelector = (appState: any) =>
  appState[STORE_FEATURE_KEY_USERS].usersSearchLoading;
const searchUsersSelector = (appState: any) =>
  appState[STORE_FEATURE_KEY_USERS].searchUsers;
const loadingIndicatorSelector = (appState: any) =>
  appState[STORE_FEATURE_KEY_USERS].loadingIndicator;
const templatesSelector = (appState: any) =>
  appState[STORE_FEATURE_KEY_USERS].templates;
const selectedUserPermissions = (user: User): PermissionItemType[] =>
  user?.userPermissions ?? [];
const selectedUserAccountSettingSelector = (appState: any) =>
  appState[STORE_FEATURE_KEY_USERS].selectedUserAccountSetting;
const selectedUserFeaturesPermissions = (user: User): FeaturePermission[] =>
  user?.featurePermissions ?? [];
const selectedFeaturesChangedFlag = (appState: any): boolean =>
  (<UsersState>appState[STORE_FEATURE_KEY_USERS]).hasFeaturesChanged;

@Injectable()
export class UserSelectors {
  constructor(private store: Store<any>) {}

  selectUsersSearchLoading(): Observable<boolean> {
    return this.store.pipe(select(usersSearchLoadingSelector));
  }

  selectSearchUsers(): Observable<Array<User>> {
    return this.store.pipe(select(searchUsersSelector));
  }

  selectSelectedUser(): Observable<User> {
    return this.store.pipe(select(selectedUserSelector));
  }

  selectTemplates(): Observable<Array<Template>> {
    return this.store.pipe(select(templatesSelector));
  }

  selectLoadingIndicatorStatus(): Observable<boolean> {
    return this.store.pipe(select(loadingIndicatorSelector));
  }

  selectSelectedUserPermissions(): Observable<PermissionItemType[]> {
    return this.store.pipe(
      select(selectedUserSelector),
      select(selectedUserPermissions)
    );
  }

  selectSelectedUserAccountSettingSelector(): Observable<any> {
    return this.store.pipe(select(selectedUserAccountSettingSelector));
  }

  selectSelectedUserFeatures(): Observable<FeaturePermission[]> {
    return this.store.pipe(
      select(selectedUserSelector),
      select(selectedUserFeaturesPermissions)
    );
  }

  selectFeatureChangedFlag(): Observable<boolean> {
    return this.store.pipe(select(selectedFeaturesChangedFlag));
  }
}
